export const enClientPortalAuthenticatedAppPages = {
    authenticatedApp: {
        subtitle: 'Value Management Platform',
        supportNote: {
            prefix: 'If you have any questions, contact us at',
            suffix: '.',
        },
        formFields: {
            email: 'Email',
            password: 'Password',
            code: 'Code',
            newPassword: 'New password',
            confirmNewPassword: 'Repeat new password',
        },
        errors: {
            signIn: 'Sign-in failed. Please check your details and try again.',
            forgotPasswordSubmit: 'Password reset failed. Please check your details and try again.',
            confirmSignIn: 'Sign-in failed. Please check your details and try again.',
        },
        signIn: {
            title: 'Welcome',
            description: 'Manage efficiently. Decide with confidence.',
            forgotPassword: 'Forgot your password?',
        },
        forgotPassword: {
            title: 'Reset password',
            description: 'Enter your email to receive a code to reset your password.',
        },
        confirmResetPassword: {
            title: 'Reset password',
            description: 'Enter the code sent by email and set your new password.',
        },
        forceNewPassword: {
            title: 'Set password',
            description: 'Set a new password to complete your sign-in.',
            minLengthError: 'Password must be at least 8 characters long',
            mismatchError: 'Passwords must match',
        },
        restrictedAppraiser: {
            title: 'Continue to the appraiser platform',
            description: 'You are on the customer platform. Please switch to our appraiser platform.',
            action: 'To appraiser platform',
        },
    },
    welcomePage: {
        title: 'Welcome to einwert',
        description: 'Before you start, please complete your user profile by clicking the button below.',
        cta: 'To profile',
    },
    errorPage: {
        emptyStateTitle: 'Welcome to einwert',
        status: {
            unauthorized: {
                title: '401 Access denied',
                message:
                    'Your access was denied. Please try signing out and back in again or refresh the page. If the problem persists, contact support.',
            },
            forbidden: {
                title: '403 Access denied',
                message: 'You do not have permission to access this content. Contact support if needed.',
            },
            notFound: {
                title: '404 Page not found',
                message: 'Sorry, something seems to have gone wrong here. The page you are looking for could not be found.',
            },
            default: {
                title: 'Oops...',
                message: 'Sorry, an unexpected error occurred.',
            },
        },
        emptyState: {
            assets: 'There is nothing to see here yet. Either you do not have permission or we have not completed your first appraisal yet.',
            analysis:
                'There is nothing to see here yet. Either you do not have permission or your first appraisal is not complete yet. You can compare your assets here once it is.',
            default:
                'There is nothing to see here yet. Either you do not have permission or your first appraisal is not complete yet. You will see your overview here once it is.',
        },
        supportText: 'If the problem persists, please contact',
        actions: {
            orders: 'Valuation orders',
            signOut: 'Sign out',
            back: 'Back',
            overview: 'Overview',
        },
    },
}
